import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

/* eslint-disable import/prefer-default-export */
export function sendNotification({ dispatch }, params) {
  return http.post(`${MINERVA_API_URL}/notifications`, params)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while sending notification:', err);
      return err;
    });
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/app/notifications/store/actions.js